import { render } from "./BusTzReceiveRecord.vue?vue&type=template&id=980f9eba&scoped=true"
import script from "./BusTzReceiveRecord.vue?vue&type=script&lang=js"
export * from "./BusTzReceiveRecord.vue?vue&type=script&lang=js"

import "./BusTzReceiveRecord.vue?vue&type=style&index=0&id=980f9eba&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980f9eba"]])

export default __exports__